export const PRIVATE = {
  GLOW_FEATURES: 'Private - Glow Features',
  SHINE_FEATURES: 'Private - Shine Features',
  LUMINATE_FEATURES: 'Private - Luminate Features',
  ADD_NEW_PLATFORM: 'Private - Add New Platform',
  DASHBOARD: 'Private - Dashboard',
  REMINDERS: 'Private - Reminders',
  AI_ASSISTANT: 'Private - AI Assistant',
  INTERNAL_NOTE: 'Private - Internal Note',
  IMMIGRATION: {
    MENU_HEADER: 'Private - IMMIGRATION Menu Header',
    LEGALIZATION_OF_STAY: 'Private - IMMIGRATION Legalization of Stay',
    LEGALIZATION_OF_WORK: 'Private - IMMIGRATION Legalization of Work',
    PROCESSES: 'Private - IMMIGRATION Processes',
  },
  ATS: {
    BOARD: 'Private - ATS Board',
    BOARD_CARD: 'Private - ATS Board Card',
    JOBS: 'Private - ATS Jobs',
    JOB: 'Private - ATS Job',
    JOB_CANDIDATE: 'Private - ATS Job Candidate',
    CANDIDATES: 'Private - ATS Candidates',
  },
  COMMUNICATION: {
    MENU_HEADER: 'Private - COMMUNICATION Menu Header',
    WHATSAPP: 'Private - COMMUNICATION WhatsApp',
  },
  LOGISTICS: {
    MENU_HEADER: 'Private - LOGISTICS Menu Header',
    FLEET: 'Private - LOGISTICS Fleet',
    RESOURCES: 'Private - LOGISTICS Resources',
  },
  SALE: {
    MENU_HEADER: 'Private - SALE Menu Header',
    LEADS: 'Private - SALE Leads',
  },
  STAFF: {
    MENU_HEADER: 'Private - STAFF Menu Header',
    EMPLOYEES: 'Private - STAFF Employees',
    EMPLOYEES_FILES: 'Private - STAFF Employees Files',
    HOUSES: 'Private - STAFF Houses',
    HOUSES_FILES: 'Private - STAFF Houses Files',
    PROJECTS: 'Private - STAFF Projects',
    PROJECTS_FILES: 'Private - STAFF Projects Files',
    WORKING_TIME_RECORDS: 'Private - STAFF Working Time Records',
    CLIENTS: 'Private - STAFF Client',
    CLIENTS_FILES: 'Private - STAFF Client Files',
    OCCUPANCY_HISTORY: 'Private - STAFF Occupancy History',
    OCCUPANCY_HARD_DELETE: 'Private - STAFF Occupancy Hard Delete',
  },
  TEMPLATE: {
    EMAIL: 'Private - TEMPLATE Email',
    WORKFLOW: 'Private - TEMPLATE Workflow',
  },
  SETTINGS: {
    COMPANY: 'Private - SETTINGS Company',
    TAGS: 'Private - SETTINGS Company tags',
    USER_MANAGEMENT: 'Private - SETTINGS User Management',
    ACCOUNT: 'Private - SETTINGS Account',

    JOBS: 'Private - Jobs Settings',
    EMPLOYEES: 'Private - Employees Settings',
    HOUSES: 'Private - Houses Settings',
    CLIENTS: 'Private - Clients Settings',
    PROJECTS: 'Private - Projects Settings',
    LEGALIZATION_OF_STAY: 'Private - SETTINGS Legalization of Stay',
    LEGALIZATION_OF_WORK: 'Private - SETTINGS Legalization of Work',
    WORKING_TIME_RECORDS: 'Private - SETTINGS Working Time Records',
    LEADS: 'Private - SETTINGS Leads',
    FLEET: 'Private - SETTINGS Fleet',
    RESOURCES: 'Private - SETTINGS Resources',
  },
}

export const PUBLIC = 'Public'

export const ACTIONS = {
  READ: 'read',
  WRITE: 'write',
  DUPLICATE: 'duplicate',
  DELETE: 'delete',
  UPDATE: 'update',
  EXPORT: 'export',
  CREATE: 'create',

  JOBS: {
    MANAGE_JOB: 'manageJob',
    MANAGE_CANDIDATES: 'manageCandidates',
    MANAGE_CANDIDATE: 'manageCandidate',
    VIEW_CANDIDATE: 'viewCandidate',
    MANAGE_JOB_STAGE: 'manageJobStage',
  },
}

export const MANAGE = 'manage'
export const ALL = 'all'

export const _ = undefined
